export default __webpack_public_path__ + "static/media/CAPABILITY_MD.93a6101b.png";